import { PersonId } from '../../types/api/primaryKeys/PrimaryKey';
import ApiRequest from '../../utils/ApiRequest';
import { DivisionDetail } from '../../types/api/divisions/DivisionDetail';

export async function getDivisionsForPerson(personId: PersonId) {
    const result = await ApiRequest.get<readonly DivisionDetail[]>(`divisions/person/${personId}`);
    return result;
}